<template>
    <d-row class="mr-3">
        <button class="btn btn-secondary mr-3" @click="exportTransactions('csv')" style="color: white;"><i class="fa">&#xf019;</i><span class="ml-1 d-none d-sm-inline-block">Export</span> (.csv)</button>
        <button class="btn btn-secondary" @click="exportTransactions('xlsx')" style="color: white;"><i class="fa">&#xf019;</i><span class="ml-1 d-none d-sm-inline-block">Export</span> (.xlsx)</button>
    </d-row>
</template>

<script>
    import { AuthService } from '@/main';
    import DateHelper from '@/helpers/date';

    export default {
        props: ['startDate', 'endDate', 'type', 'page'],

        data() {
            return {
                restUrl: process.env.VUE_APP_REST_API,
                token: AuthService.getToken()
            }
        },

        methods: {
            exportTransactions(format) {
                this.$emit(
                    "exportPerformance",
                    format
                );
                return;
            },
        }
    }
</script>
